import React from 'react'
import { withShouldUpdate } from '../../../components/hocs'

export const DynamicRoutesWrapper = withShouldUpdate((props: any) => {
  return <>{props.children}</>
})
